import { isPlatformBrowser } from '@angular/common';
import { computed, effect, Injectable, inject, type OnDestroy, PLATFORM_ID } from '@angular/core';
import { AuthService } from '../auth/services/auth.service';
import { MicrosoftTeamsIntegrationService } from './microsoft-teams-integration.service';

@Injectable({
  providedIn: 'root',
})
export class ConsoleService implements OnDestroy {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly authService = inject(AuthService);
  private readonly microsoftTeamsIntegrationService = inject(MicrosoftTeamsIntegrationService);

  // biome-ignore lint/suspicious/noExplicitAny: cannot import vConsole type here
  private vConsole?: any;

  private readonly consoleEnabled = computed(
    () =>
      this.microsoftTeamsIntegrationService.isMicrosoftTeamsEnvironment() && this.authService.currentUser()?.developer
  );

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      effect(() => {
        if (this.consoleEnabled()) {
          this.activateConsole();
        } else {
          this.deactivateConsole();
        }
      });
    }
  }

  ngOnDestroy() {
    this.deactivateConsole();
  }

  private activateConsole() {
    if (!this.vConsole) {
      import('vconsole').then((module) => {
        this.vConsole = new module.default();
        console.log('vConsole activated');
      });
    }
  }

  private deactivateConsole() {
    if (this.vConsole) {
      this.vConsole.destroy();
      this.vConsole = undefined;
      console.log('vConsole deactivated');
    }
  }
}
